
import { environment } from "../../environments/environment";
import { KeycloakConfig } from 'keycloak-js';


const keycloakConfig: KeycloakConfig = {
  url: environment.keycloakUrl,
  realm: environment.realm,
  clientId: environment.clientId
};

export default keycloakConfig;
